export function toCamelCase(name) {
    if (typeof name !== 'string') {
        return name;
    }
    return name.replace(/(-|^)(.)/g, function (match, dash, letter) { return letter.toUpperCase(); });
}
//# sourceMappingURL=to-camel-case.js.map